export type InterviewQualityStatus =
  'not_assessed' | 'not_applicable' | 'pending' | 'completed' | 'incomplete' | 'invalid';

export type InterviewQualityProcessingStatus =
  'pending' | 'processing' | 'completed' | 'failed' | 'not_applicable';

export type InterviewQualityFilter = InterviewQualityStatus | 'qa_failed';

export const INTERVIEW_QUALITY_LABELS: Record<InterviewQualityFilter, string> = {
  not_assessed: 'Not assessed',
  pending: 'Pending',
  qa_failed: 'QA failed',
  not_applicable: 'Not applicable',
  completed: 'Completed',
  incomplete: 'Incomplete',
  invalid: 'Invalid',
};

export function formatInterviewQuality(interview: {
  qualityStatus: InterviewQualityStatus;
  qualityProcessingStatus?: InterviewQualityProcessingStatus | undefined;
}): string {
  return INTERVIEW_QUALITY_LABELS[
    interview.qualityStatus === 'pending' && interview.qualityProcessingStatus === 'failed'
      ? 'qa_failed'
      : interview.qualityStatus
  ];
}
